// index.js
// Component for Client item

// Imports
import React from 'react';
import { Colors } from "@blueprintjs/core";
import EditableText from '../Common/EditableText';
import RemoveButton from '../Common/RemoveButton';
import PropTypes from 'prop-types';

// Component Class
// Shows Client item
class ClientView extends React.Component {
  // Renames the Client
  rename = (name) => {
    this.props.rename(this.props.client.id, name);
  };

  // Removes the Client
  remove = () => {
    this.props.remove(this.props.client.id);
  }

  // Renders Component
  render() {
    var lineStyle = this.props.order > 0 ? {backgroundColor: Colors.GREEN5} : null;
    return (
      <tr style={{verticalAlignment: 'middle', ...lineStyle}}>
        <td><EditableText value={this.props.client.name} placeholder="Nome do Cliente" rename={this.rename} /></td>
        <td>
          <center>
            R$ {this.props.order.toFixed(2)}
          </center>
        </td>
        <td>
          <center>
            <RemoveButton
              itemName={this.props.client.name}
              confirmation="Você tem certeza que deseja remover este cliente?"
              remove={this.remove}
            />
          </center>
        </td>
      </tr>
    );
  }
}

// Required Properties
ClientView.propTypes = {
  client: PropTypes.object.isRequired,
  order: PropTypes.number.isRequired,
}

// Exports
export default ClientView;


// WEBPACK FOOTER //
// ./src/components/ClientView/Client.js